// MessageActions.jsx

import React from 'react';

// CSS
import './MessageActions.css';

// Components
import Button from 'components/button/Button';

/**
 * MessageActions
 *
 * @returns {ReactNode} The rendered component.
 */
const MessageActions = React.memo(({
  isVisible,
  theme,
  onToggleEdit,
  onDelete,
  onReplyInThread,
  showReplyInThread = false,
  showEdit = true,
  showDelete = true,
}) => {

  if (!isVisible) return null;

  const sharedActionProps = {
    iconColor: theme.foregroundMuted,
    backgroundColor: "transparent",
    hoverForegroundColor: theme.foreground,
    iconSize: '16',
    height: '32px',
    width: '32px',
    padding: '7px',
    borderRadius: '8px',
  };

  // ----- RENDER ----- //

  return (
    <div className="message-actions">
      {showReplyInThread ? (
        <Button
          {...sharedActionProps}
          iconKey="chat"
          onClick={onReplyInThread}
        />
      ) : null}

      {showEdit ? (
        <Button
          {...sharedActionProps}
          iconKey="edit"
          onClick={onToggleEdit}
        />
      ) : null}

      {showDelete ? (
        <Button
          {...sharedActionProps}
          iconKey="delete"
          onClick={onDelete}
        />
      ) : null}
    </div>
  );
});

// Dev Tools
MessageActions.displayName = 'MessageActions';

export default MessageActions;
